import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  ANALYTICS_RANGE_PRESETS,
  OFFER_CLAIM_STATUSES,
  OFFER_GUEST_NUDGES,
  type AnalyticsRangePreset,
  type OfferClaimStatus,
  type OfferGuestNudge,
} from '@repo/shared/marketing';
import { OfferGuestsPage, type OfferGuestsSearch } from '@/features/new-client-offer';

const oneOf = <T extends string>(value: unknown, allowed: readonly T[]): T | undefined =>
  typeof value === 'string' && (allowed as readonly string[]).includes(value) ? (value as T) : undefined;

const text = (value: unknown, max: number) =>
  typeof value === 'string' && value.length > 0 && value.length <= max ? value : undefined;

export const Route = createFileRoute('/_auth/$orgId/marketing/new-client-offer/guests')({
  validateSearch: (search: Record<string, unknown>): OfferGuestsSearch => ({
    status: oneOf<OfferClaimStatus>(search.status, OFFER_CLAIM_STATUSES),
    source: text(search.source, 120),
    nudge: oneOf<OfferGuestNudge>(search.nudge, OFFER_GUEST_NUDGES),
    range: oneOf<AnalyticsRangePreset>(search.range, ANALYTICS_RANGE_PRESETS),
    claim: text(search.claim, 64),
  }),
  component: GuestsRoute,
});

function GuestsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: '/$orgId/marketing/new-client-offer/guests' });
  // Opening / closing a guest replaces the history entry; filter changes push one (Back undoes a filter).
  return (
    <OfferGuestsPage
      search={search}
      onChangeSearch={(next) =>
        void navigate({ search: next, replace: next.claim !== search.claim })
      }
    />
  );
}
